import React from 'react';
import {BarChart3, Eye, Zap} from 'lucide-react';
import {ProductDirectionItem} from '../../pages/site/site.types';
import SiteLink from './SiteLink';
import styles from './styles/ProductSwitchShowcase.module.css';

const keyIcon: Record<string, React.ReactNode> = {
    'assist-trading': <Eye size={20}/>,
    'auto-trading': <Zap size={20}/>,
    'asset-allocation': <BarChart3 size={20}/>
};

interface ProductSwitchShowcaseProps {
    items: ProductDirectionItem[];
}

const ProductSwitchShowcase: React.FC<ProductSwitchShowcaseProps> = ({items}) => {
    if (!items.length) {
        return null;
    }

    return (
        <section className={styles.wrap}>
            <div className={styles.cardGrid}>
                {items.map(item => (
                    <SiteLink className={`site-card ${styles.card}`} key={item.key} to={item.ctaTo}>
                        <span className={styles.cardEyebrow}>{item.slogan}</span>
                        <div className={styles.cardRow}>
                            <span className={styles.cardIcon}>{keyIcon[item.key]}</span>
                            <strong className={styles.cardLabel}>{item.label}</strong>
                        </div>
                        <small className={styles.cardDesc}>{item.description}</small>
                    </SiteLink>
                ))}
            </div>
        </section>
    );
};

export default ProductSwitchShowcase;
